
import { Category } from "@/constants/FAQ_LIST";
import { computed, defineComponent, watch, ref, onMounted } from "vue";

export default defineComponent({
	props: {
		category: { type: Object as () => Category, required: true },
		categoryKey: { type: String, required: true },
		questionKey: String,
		headerHeight: { type: Number, required: true },
	},
	setup: (props) => {
		const open = ref(false);
		const category = computed(() => props.category);
		const categoryKey = computed(() => props.categoryKey);
		const questionKey = computed(() => props.questionKey);
		const headerHeight = computed(() => props.headerHeight);
		const container = ref();
		const questions: HTMLElement[] = [];
		const setQuestions = (el: any) => questions.push(el);
		const toggle = () => (open.value = !open.value);

		onMounted(() => {
			if (categoryKey.value == category.value.key) open.value = true;
		});

		watch(questionKey, () => {
			if (open.value && container.value instanceof HTMLElement) {
				setTimeout(() => {
					let top = container.value.offsetTop - headerHeight.value;
					if (questionKey.value) {
						const question = questions.find((v) => v.id == questionKey.value);
						if (question) top += question.offsetTop;
					}
					window.scrollTo({ top, behavior: "smooth" });
				}, 300);
			}
		});

		return { open, toggle, container, setQuestions };
	},
});
